import React from 'react';

export default class Mock extends React.Component {
    render() {
        return (
        <div>
            <h2><em>Mock Credentials</em></h2>
            <h4>Username: admin</h4>
            <h4> Password: pass</h4>
        </div>
        );
      }
}
